module.exports = __webpack_public_path__ + "img/derby-university.e03a31f2.png";